/** Format a discipline metric for display (board + results), with the right unit. */
export function formatMetric(disciplineId: string, kind: 'time' | 'distance', v: number): string {
  if (disciplineId === 'weightlifting') return `${Math.round(v)} kg`;
  if (disciplineId === 'diving' || disciplineId === 'archery') return `${Math.round(v)} pt`;
  if (kind === 'time') return `${v.toFixed(2)}"`;
  return `${v.toFixed(2)} m`;
}
